import http from '../../http';
import { InvestorResource } from '../entities';
import { JsonApiResponse } from '../interfaces';

const resource = 'investors';

/**
 * @description Retrieves all investor records.
 * @return {Promise<InvestorResource[]>}
 */
const getAll = async (): Promise<InvestorResource[]> => {
  const response = await http.get<JsonApiResponse<InvestorResource[]>>(
    `/${resource}`,
  );
  return response.data.data;
};

/**
 * @description Retrieves all investor records and meta data.
 * @param {Record<string, string>} filters
 * @param {Record<string, string>} page
 * @return {Promise<JsonApiResponse<InvestorResource[]>>}
 */
const getAllWithMeta = async (
  filters?: Record<string, string>,
  page?: Record<string, string>,
): Promise<JsonApiResponse<InvestorResource[]>> => {
  const filtersString = filters
    ? `${Object.keys(filters)
        .map((key) => `filter[${key}]=${filters[key]}`)
        .join('&')}`
    : '';
  const pageString = page
    ? `${Object.keys(page)
        .map((key) => `page[${key}]=${page[key]}`)
        .join('&')}`
    : '';

  const response = await http.get<JsonApiResponse<InvestorResource[]>>(
    `/${resource}?${[filtersString, pageString].join('&')}`,
  );
  return response.data;
};

/**
 * @description Retrieves a single investor record.
 * @param {string} id
 * @return {Promise<Investor>}
 */
const get = async (id: string): Promise<InvestorResource> => {
  const response = await http.get<JsonApiResponse<InvestorResource>>(
    `/${resource}/${id}`,
  );
  return response.data.data;
};

// findByTitle(title: string) {
//   return http.get<Investor[]>(`/${resource}?title=${title}`);
// }

const InvestorsDataService = {
  getAll,
  get,
  getAllWithMeta,
};

export default InvestorsDataService;
